import { createContext, ReactNode, useContext } from "react";
import { PropRarityWeight } from "../shared/types/PropRarityWeight";
import { ContextType, DataProvider } from "./DataProvider";

const PropRarityWeightDataContext =
  createContext<ContextType<PropRarityWeight> | null>(null);

export const PropRarityWeightDataProvider = ({
  children,
}: {
  children: ReactNode;
}) => (
  <DataProvider
    context={PropRarityWeightDataContext}
    collection="proprarityweights"
  >
    {children}
  </DataProvider>
);

export const usePropRarityWeightData = () => {
  const context = useContext(PropRarityWeightDataContext);
  if (context === null) {
    throw new Error(
      "usePropRarityWeightData must be used within a PropRarityWeightDataProvider",
    );
  }
  return context;
};
